// extracted by mini-css-extract-plugin
export var arrows = "_3s-6";
export var decrementer = "_3s-a";
export var disabled = "_3s-4";
export var error = "_3s-1";
export var hiddenText = "_3s-b";
export var incrementer = "_3s-9";
export var input = "_3s-8";
export var inputWrapper = "_3s-0";
export var leadingIcon = "_3s-c";
export var readonly = "_3s-3";
export var regular = "_3s-7";
export var small = "_3s-5";
export var warning = "_3s-2";